module.exports = __webpack_public_path__ + "img/side-icon-32-off.f5c2642f.svg";